import { Routes } from "@angular/router";

export const TASK_ROUTES: Routes = [
  {
    path: "list",
    loadComponent: () =>
      import("./pages/task-list/task-list.component").then(
        (m) => m.TaskListComponent,
      ),
    title: "Tasks Overview - Foresight",
    data: {
      breadcrumb: "Tasks Overview",
      pageId: "tasks-overview",
    },
  },
  {
    path: "view/:id",
    loadComponent: () =>
      import("./pages/view-task/view-task.component").then(
        (m) => m.ViewTaskComponent,
      ),
    title: "Task Details - Foresight",
    data: {
      breadcrumb: "Task Details",
      pageId: "task-details",
    },
  },
  { path: "", redirectTo: "list", pathMatch: "full" },
];
